import { Routes } from '@angular/router';

import {FaqComponent} from './faq.component';


export const faqRoute: Routes = [
  {
    path: 'faq',
    component: FaqComponent,
    data: {
        pageTitle: 'cadensApp.faq.title'
    }
  }
];




// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/faq/faq.route.ts